module.exports = __webpack_public_path__ + "img/impiantoviola.12349b35.png";